import { LanguageService } from '../../../services/LanguageService';
import { OperatorHelpers } from './OperatorHelper'
import Utils from '../../../services/Utils';
import { Auth } from "../../../services/Auth";
import store from '../../../index';
import { ConditionOperatorsEnum, ConditionsEnum, VerificationStatusEnum } from '../../../constants/Enums/BusinessRulesEnum'
import { HeaderDeviceTypeEnum } from '../../../constants/DeviceTypeEnum';

export const ConditionHelper = {
  /** This function Maps over conditions calls conditionsHandler then returns sum result
* @function
* @param {Array} conditions  Trigger conditions array
* @returns {bool} is  conditions  sum true or false
*/
  conditionsMap(conditions) {
    const conditionsArr = conditions.map((condition) => ConditionHelper.conditionHandler(condition))
    return OperatorHelpers.and(conditionsArr)
  },

  /** This function handle each condition type 
     * @function
     * 
     * @param {Object} condition object , consist of unique name and operations object
     * @returns {bool} is  condition operations sum true or false
    */
  conditionHandler({ name, operations }) {
    switch (name) {
      case ConditionsEnum.PageURLCondition:
        return OperatorHelpers.and(operations.map((operator) => {
          return OperatorHelpers.and(operator.values.map((val) => {
            let conditionUrl = val
            
            let isAbsolutePath = Utils.checkAbsolutePath(conditionUrl)
            let url = window.location.href
            switch (operator.name) {
              case ConditionOperatorsEnum.isNot:
              case ConditionOperatorsEnum.is:
                if (!isAbsolutePath) {
                  url = window.location.pathname
                  conditionUrl = Utils.isLanguageInPath(conditionUrl, LanguageService.getSelectedLanguage()) ? conditionUrl : `/${LanguageService.getSelectedLanguage()}${conditionUrl}`
              }else{
                conditionUrl = /^https?:\/\//.test(conditionUrl) ? conditionUrl : `${window.location.protocol}//${conditionUrl}` 
                }
                break;
              case ConditionOperatorsEnum.contains:
              case ConditionOperatorsEnum.doesNotContain:
                url = window.location.pathname
                break;
              default:
                break;
            }
            return OperatorHelpers[Utils.camelCase(operator.name)](url, conditionUrl)
          }))
         }))

      case ConditionsEnum.AuthorizationStatusCondition:
        const authStatus = Auth.isAuthenticated() ? '1' : '2'
        return OperatorHelpers.and(operations.map((operator) => OperatorHelpers[Utils.camelCase(operator.name)](operator.values[0], authStatus)));

      case ConditionsEnum.LocationCondition:
        let { country } = store.getState().settings;
        return OperatorHelpers.and(operations.map((operator) => OperatorHelpers[Utils.camelCase(operator.name)](operator.values, country)))

      case ConditionsEnum.VerificationStatusCondition:
        if (Auth.isAuthenticated()) {
          const { isMobileNumberVerified, isEmailVerified, isDocumentVerified, isPhysicalVerified, isCitizenshipVerified, isAddressVerified } = store.getState().user.playerData.player
          let verifiedData = [];
          isMobileNumberVerified && verifiedData.push(`${VerificationStatusEnum.Mobile}`);
          isEmailVerified && verifiedData.push(`${VerificationStatusEnum.Email}`);
          isDocumentVerified && verifiedData.push(`${VerificationStatusEnum.Document}`);
          isPhysicalVerified && verifiedData.push(`${VerificationStatusEnum.Physical}`);
          isCitizenshipVerified && verifiedData.push(`${VerificationStatusEnum.Citizenship}`);
          isAddressVerified && verifiedData.push(`${VerificationStatusEnum.Address}`);
          verifiedData.length === 0 && verifiedData.push(`0`);
          return OperatorHelpers.and(operations.map((operator) => verifiedData.some(v => OperatorHelpers[Utils.camelCase(operator.name)](operator.values, v))))
        } else {
          return false
        }
      case ConditionsEnum.DeviceTypeCondition:
        const deviceType = Utils.isTablet() ? HeaderDeviceTypeEnum.Mobile : HeaderDeviceTypeEnum.Desktop
        return OperatorHelpers.and(operations.map((operator) => OperatorHelpers[Utils.camelCase(operator.name)](+operator.values[0], deviceType)))

      default:
        return false;
    }
  }
}